exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ChangeStatusPopups_title_2hai {\n  margin-bottom: 20px !important;\n}\n\n.ChangeStatusPopups_subtitle_hcol {\n  max-width: 460px;\n}\n\n.ChangeStatusPopups_formDescription_1aJ4 {\n  margin-top: 50px;\n  margin-bottom: 20px;\n}\n\n.ChangeStatusPopups_form_gJQx {\n  width: auto;\n}\n\n.ChangeStatusPopups_input_3fA9 {\n  margin: 0 10px 20px;\n\n  width: 215px;\n}\n\n.ChangeStatusPopups_button_vfnb {\n  margin: 0 10px;\n}\n\n.ChangeStatusPopups_message_o0Sv .ChangeStatusPopups_button_vfnb {\n  margin-top: 30px;\n}\n\n.ChangeStatusPopups_preloader_1zHN {\n  position: static;\n  margin: 17px 0;\n\n  -webkit-transform: none;\n\n          transform: none;\n}\n\n.ChangeStatusPopups_isLoading_3wWW .ChangeStatusPopups_subtitle_hcol,\n  .ChangeStatusPopups_isLoading_3wWW .ChangeStatusPopups_form_gJQx,\n  .ChangeStatusPopups_isLoading_3wWW .ChangeStatusPopups_button_vfnb {\n  display: none;\n}\n", ""]);

// exports
exports.locals = {
	"title": "ChangeStatusPopups_title_2hai",
	"subtitle": "ChangeStatusPopups_subtitle_hcol",
	"formDescription": "ChangeStatusPopups_formDescription_1aJ4",
	"form": "ChangeStatusPopups_form_gJQx",
	"input": "ChangeStatusPopups_input_3fA9",
	"button": "ChangeStatusPopups_button_vfnb",
	"message": "ChangeStatusPopups_message_o0Sv",
	"preloader": "ChangeStatusPopups_preloader_1zHN",
	"isLoading": "ChangeStatusPopups_isLoading_3wWW"
};